"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var _defineProperty2 = require("babel-runtime/helpers/defineProperty"),
    _defineProperty3 = _interopRequireDefault(_defineProperty2),
    _extends4 = require("babel-runtime/helpers/extends"),
    _extends5 = _interopRequireDefault(_extends4),
    _stringify = require("babel-runtime/core-js/json/stringify"),
    _stringify2 = _interopRequireDefault(_stringify);

exports.onRecordSave = onRecordSave;

var _get = require("lodash/get"),
    _get2 = _interopRequireDefault(_get),
    _utils = require("@heartfulnessinstitute/react-hfn-forms/dist/utils"),
    _lodash = require("lodash");

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

function onRecordSave(a) {
  var b = a.Config,
      c = a.dbStore,
      d = a.data,
      e = a.values,
      f = e === void 0 ? {} : e,
      g = a.success_callback,
      h = g === void 0 ? function () {} : g,
      i = a.failure_callback,
      j = i === void 0 ? alert : i,
      k = a.metaParams,
      l = k === void 0 ? {} : k,
      m = b.postprocess(d, f);
  if ((0, _stringify2.default)(f) === (0, _stringify2.default)(m)) return void j("Nothing Changed");
  var n = b.autogenPrimaryKey,
      o = b.postSave,
      p = (0, _get2.default)(b, ["db", "type"], "firestore"),
      q = "srcmstore" === p || n,
      r = "firestore" === p;
  !q || (0, _lodash.has)(m, b.primaryKey) || (0, _lodash.has)(f, b.primaryKey) || ("srcmstore" === p ? m = (0, _extends5.default)({}, m, (0, _defineProperty3.default)({}, b.primaryKey, 0)) : m = (0, _extends5.default)({}, m, (0, _defineProperty3.default)({}, b.primaryKey, (0, _utils.genNewUuid)().replace(/-/g, "").slice(0, 20))));
  var s = (0, _get2.default)(f, b.primaryKey, ""),
      t = (0, _get2.default)(m, b.primaryKey, s);
  if (!t && !n) return void j("Missing " + b.primaryKey);
  var u = h,
      v = !o ? function () {} : function () {
    return o({
      dbStore: c
    });
  }; //console.log("POSTSAVE CALLBACK");

  q || t === s && b.primaryKey in f ? r ? (c.setMerge(b.collection, t, m, l).then(v).catch(j), u()) : c.setMerge(b.collection, t, m, l).then(u).then(v).catch(j) : c.get(b.collection, t, l).then(function (a) {
    return a.exists ? void j(t + " already exists! Choose Another value") : void (s && t !== s ? c.setMerge(b.collection, t, m, l).then(function () {
      c.delete(b.collection, s, l).then(u).then(v);
    }).catch(j) : r ? (c.setOverwrite(b.collection, t, m, l).then(v).catch(j), u()) : c.setOverwrite(b.collection, t, m, l).then(u).then(v).catch(j));
  });
}